<template>
  <div class="geo-item-search land-ap-emergency">
    <GeoItemSearchCommon
      v-model:search-params="commonSearchParams"
      :checkbox-key-prefix="checkboxKeyPrefix"
      :search-types="emergencyTypes"
      :search-type-map="emergencyTypeMap"
      :search-type-default-values="emergencyTypesDefaultValues"
      :default-days-before="7"
      @change="onChange"
    >
    </GeoItemSearchCommon>
  </div>
</template>

<script setup lang="ts">
import GeoItemSearchCommon from 'src/components/Top/geoItemSearchComponents/GeoItemSearchCommon.vue';
import type { CommonSearchParams } from 'src/models/geoItemSearch';
import { emergencyTypeMap, emergencyTypes } from 'src/consts/ext_land_emergencies';
import { ref } from 'vue';
import type { EmergencyIndexParams } from 'src/models/apis/extLandApEmergency/extLandApEmergencyRequest';

const emit = defineEmits<{
  (e: 'change'): void;
}>();

const checkboxKeyPrefix = 'emg';
// 初期表示は「緊急」だけチェック
const emergencyTypesDefaultValues = [1];
const commonSearchParams = ref<CommonSearchParams | null>(null);
// methods
const getSearchParams = (): EmergencyIndexParams | null => {
  if (!commonSearchParams.value) return null;

  const {
    searchTypes: movieTypes,
    tsFrom: startTs,
    tsTo: endTs,
    ...other
  } = commonSearchParams.value;
  return {
    movie_types: movieTypes as number[],
    start_ts: startTs,
    end_ts: endTs,
    road_names: other.roadNameDisps,
    directions: other.directions,
    kp_calc_from: other.kpCalcFrom,
    kp_calc_to: other.kpCalcTo,
  };
};
const onChange = () => {
  emit('change');
};

defineExpose({ getSearchParams });
</script>

<style lang="scss" scoped>
.geo-item-search {
  &.land-ap-emergency {
    margin: 0 0 0 25px;
  }
}
</style>
